import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { locale as defaultLocale } from 'expo-localization';

import { useAppSelector } from 'store/hooks';
import { UserSelectors } from 'store/User';

const getLocaleNumberString = (
  value: number | string,
  options: Intl.NumberFormatOptions = {},
  locale = defaultLocale,
): string => {
  let _value = value;

  if (typeof _value === 'string') {
    _value = parseFloat(_value);
  }

  return _value.toLocaleString(locale, {
    ...options,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const getCurrencyString = (
  value?: number | string | null,
  currency?: string,
  locale = defaultLocale,
) => {
  if (!value) return '-';

  if (currency) {
    return getLocaleNumberString(
      value,
      {
        currencyDisplay: 'narrowSymbol',
        style: 'currency',
        currency,
      },
      locale,
    ).replace(/^[a-z]+(?!(\s|\w))/gi, '');
  }

  return getLocaleNumberString(value, undefined, locale);
};

export const useCurrencyString = () => {
  const currency = useAppSelector(UserSelectors.selectCurrencyCode);
  const {
    i18n: { resolvedLanguage },
  } = useTranslation();

  return useCallback(
    (value?: number | string | null) => {
      return getCurrencyString(value, currency, resolvedLanguage);
    },
    [currency, resolvedLanguage],
  );
};
